import React, { useRef } from "react";
import style from "css/workspace.module.css";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useMediaQuery } from "react-responsive";

function Detailvideocommon(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "40px",
      }}
    >
      <div className={style.detailvideoCommonImgWrap}>
        <img
          alt=""
          src={
            !isMobile && !isTablet
              ? `${process.env.REACT_APP_CLIENT_URL}img/smartspace/vcHeader_${props.status}.png`
              : `${process.env.REACT_APP_CLIENT_URL}img/smartspace/vcHeader_${
                  props.status + "_m"
                }.png`
          }
          style={{ width: "100%" }}
        />
      </div>
      <div className={style.detailvideoCommonInfo1}>
        <p>{props.commonInfo.info1}</p>
        <p>{props.commonInfo.info2}</p>
        <div />
        <p>{props.commonInfo.info3}</p>
        <div>
          {props.commonInfo.info4.map((info) => (
            <p>{info.txt}</p>
          ))}
        </div>
        <div>
          <img
            alt=""
            src={
              !isMobile && !isTablet
                ? `${process.env.REACT_APP_CLIENT_URL + props.commonInfo.img1}`
                : `${
                    process.env.REACT_APP_CLIENT_URL + props.commonInfo.img1_m
                  }`
            }
          />
          <img
            alt=""
            src={
              !isMobile && !isTablet
                ? `${process.env.REACT_APP_CLIENT_URL + props.commonInfo.img2}`
                : `${
                    process.env.REACT_APP_CLIENT_URL + props.commonInfo.img2_m
                  }`
            }
          />
        </div>
      </div>
      <div className={style.detailvideoCommonInfo2}>
        {props.commonInfo.info5}
        {props.commonInfo.info6}
        <div
          className={
            props.status !== "individual" && props.status !== ""
              ? style.infoImgChange
              : ""
          }
        >
          <div className={style.infoImgWrap}>
            <img
              alt=""
              src={
                !isMobile && !isTablet
                  ? `${
                      process.env.REACT_APP_CLIENT_URL + props.commonInfo.img3
                    }`
                  : `${
                      process.env.REACT_APP_CLIENT_URL + props.commonInfo.img3_m
                    }`
              }
            />
            <div className={style.infoImgLabel}>
              {props.commonInfo.imgLabel3}
            </div>
          </div>
          <div className={style.infoImgWrap}>
            <img
              alt=""
              src={
                !isMobile && !isTablet
                  ? `${
                      process.env.REACT_APP_CLIENT_URL + props.commonInfo.img4
                    }`
                  : `${
                      process.env.REACT_APP_CLIENT_URL + props.commonInfo.img4_m
                    }`
              }
            />
            <div className={style.infoImgLabel}>
              {props.commonInfo.imgLabel4}
            </div>
          </div>
        </div>
      </div>
      <div className={style.commonBody} style={{ borderTop: "none" }}>
        {props.bodyHeader}

        <div className={style.bodyInfoWrap}>
          {props.bodyInfo.map((info) =>
            isMobile ||
            isTablet ||
            (!isMobile && !isTablet && info.id % 2 === 1) ? (
              <div className={style.bodyInfo}>
                <div className={style.bodyInfoImg}>
                  <img
                    alt=""
                    src={
                      !isMobile && !isTablet
                        ? `${process.env.REACT_APP_CLIENT_URL + info.img}`
                        : `${process.env.REACT_APP_CLIENT_URL + info.img_m}`
                    }
                  />
                </div>
                <div className={style.bodyInfoTxt}>
                  <div className={style.bodyInfoTxtBody}>
                    <p>{info.id}</p>
                    <p>{info.title}</p>
                    {info.txt}
                  </div>
                </div>
              </div>
            ) : (
              <div className={style.bodyInfo}>
                <div className={style.bodyInfoTxt}>
                  <div className={style.bodyInfoTxtBody}>
                    <p>{info.id}</p>
                    <p>{info.title}</p>
                    {info.txt}
                  </div>
                </div>
                <div className={style.bodyInfoImg}>
                  <img
                    alt=""
                    src={
                      !isMobile && !isTablet
                        ? `${process.env.REACT_APP_CLIENT_URL + info.img}`
                        : `${process.env.REACT_APP_CLIENT_URL + info.img_m}`
                    }
                  />
                </div>
              </div>
            )
          )}
        </div>
      </div>
      <div className={style.commonCompose}>
        <div className={style.commonCompseBody}>
          {/* {props.composeHeader} */}
          <div className={style.commonComposeTitle}>
            화상회의 시스템 <strong>구성 환경</strong>
          </div>

          <Swiper
            scrollbar={{ draggable: true }}
            slidesPerView={"auto"}
            spaceBetween={50}
            modules={[Scrollbar]}
            className={style.commonComposeCardWrap}
            observer={true}
            observeParents={true}
            observeSlideChildren={true}
            grabCursor={true}
          >
            {props.compose.map((info, index) => (
              <SwiperSlide className={style.commonComposeCard} key={index}>
                <div
                  className={
                    info.link === "/smart-space/work/platform"
                      ? `${style.commonComposeCardImg} ${style.platform}`
                      : style.commonComposeCardImg
                  }
                >
                  <p>
                    <font>{info.id}</font> / {props.compose.length}
                  </p>
                  <img
                    alt=""
                    src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                  />
                </div>
                <div className={style.commonComposeCardTxt}>
                  <p>{info.title}</p>
                  <p>{info.txt}</p>
                </div>
                <div className={style.commonComposeCardMore}>
                  {/* <Link to={`${process.env.REACT_APP_CLIENT_URL + info.link}`}> */}
                  <div onClick={info.onClick}>
                    <font>More</font>{" "}
                    <img
                      alt=""
                      src={
                        `${process.env.REACT_APP_CLIENT_URL}` +
                        "img/smartspace/arrowRight.png"
                      }
                    />
                  </div>
                  {/* </Link> */}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className={style.commonComposeFooter}>
            <div
              style={{
                backgroundImage:
                  "url('" +
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/smartspace/composefooterImg.png')",
              }}
            >
              <p>
                <img
                  alt=""
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/bang.png"
                  }
                />
              </p>
              <p>
                <font>기업 환경에 맞춰</font> 선택하여 구축 가능합니다. 상담을
                통해 정확히 진단해 보세요.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Detailvideocommon;
